import type {Context} from '../types';

// Strip out unneeded clearfix: false flags
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;

  return {
    needed: data && data.clearfix === false,
    logData: {
      msg: 'Node with false data.clearfix',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // eslint-disable-next-line webflow/no-delete
      delete data.clearfix;
    },
  };
};
